import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { I18nProvider } from "./i18n";
import { CartProvider } from "./cart";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import OrderConfirmation from "./pages/OrderConfirmation";
import Collections from "./pages/Collections";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children, hideChrome }) {
  return (
    <div className="bg-black min-h-screen grain">
      {!hideChrome && <Header />}
      {!hideChrome && <CartDrawer />}
      <main>{children}</main>
      {!hideChrome && <Footer />}
    </div>
  );
}

function AdminRoute() {
  return (
    <Layout hideChrome={true}>
      <Admin />
    </Layout>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/admin" element={<AdminRoute />} />
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/shop" element={<Layout><Shop /></Layout>} />
            <Route path="/collections" element={<Layout><Collections /></Layout>} />
            <Route path="/product/:id" element={<Layout><ProductDetail /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/order/:id" element={<Layout><OrderConfirmation /></Layout>} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </I18nProvider>
  );
}
